import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconSuccess = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 35 35'>
    <title>{t('Success')}</title>
    <g transform='translate(-2 -2)' fill='none' fillRule='evenodd'>
      <rect width={39} height={39} rx={5} />
      <path
        d='M19.5 34.5c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15m0-32.5C9.85 2 2 9.85 2 19.5S9.85 37 19.5 37 37 29.15 37 19.5 29.15 2 19.5 2m6.923 11.625l-9.412 9.401-4.356-4.462a1.25 1.25 0 1 0-1.789 1.746l5.24 5.366c.233.239.552.374.887.376H17c.331 0 .649-.131.884-.365L28.19 15.395a1.251 1.251 0 0 0-1.767-1.77'
        fill={fill}
      />
    </g>
  </svg>
)

export default Icon(IconSuccess)
